import { Component, inject } from '@angular/core';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';
import { firstValueFrom, Observable } from 'rxjs';
import { CommonModalService, generateId, OptionsList } from 'gung-common';
import { CustomPageConfigService } from '../../../../../services/custom-page/custom-page-config.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageConfigService } from '../../../../../services/language-config/language-config.service';

@Component({
  selector: 'lib-dynamic-page-dc-info-card',
  standalone: false,
  templateUrl: './dynamic-page-dc-info-card.component.html',
  styleUrl: './dynamic-page-dc-info-card.component.scss'
})
export class DynamicPageDcInfoCardComponent extends DynamicPageDcBaseComponent {
  protected customPagesService = inject(CustomPageConfigService);
  protected modalService = inject(CommonModalService);
  protected translateService = inject(TranslateService);
  protected languageConfigService = inject(LanguageConfigService);

  translateLangs = this.languageConfigService
    .getLanguages()
    .filter(l => l.enabled)
    .map(l => l.short);

  currentLang = this.translateService.currentLang;

  idUploadInput = generateId();
  imageUpload: File[];
  translate = false;

  elementId = 'card-info';
  fields = {
    translate: false,
    title: '<h4 style="text-align: center;"><span style="font-weight: normal;">Card Title</span></h4>',
    description: 'Description',
    backgroundColor: 'transparent',
    backgroundImage: null,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 15,
    paddingRight: 15,
    paddingBottom: 15,
    paddingLeft: 15,
    minHeight: 200,
    tabletMinHeight: null,
    mobileMinHeight: null,
    buttonGroupAlignment: 'justify-content-center',
    button1Text: 'Button 1',
    button1Color: '#ffffff',
    button1FontSize: 16,
    button1MarginTop: 0,
    button1MarginRight: 0,
    button1MarginBottom: 0,
    button1MarginLeft: 0,
    button1PaddingTop: 5,
    button1PaddingRight: 15,
    button1PaddingBottom: 5,
    button1PaddingLeft: 15,
    button1Background: '#000000',
    button1Width: null,
    button1Link: '',
    button1HoverBackground: null,
    button1HoverColor: null,
    button2Enable: true,
    button2Text: 'Button 2',
    button2FontSize: 16,
    button2Color: '#ffffff',
    button2MarginTop: 0,
    button2MarginRight: 0,
    button2MarginBottom: 0,
    button2MarginLeft: 10,
    button2PaddingTop: 5,
    button2PaddingRight: 15,
    button2PaddingBottom: 5,
    button2PaddingLeft: 15,
    button2Background: '#000000',
    button2Width: null,
    button2Link: '',
    button2HoverBackground: null,
    button2HoverColor: null,
    displayVertical: 'align-items-center',
    displayHorizontal: 'justify-content-center',
    contentMaxWidth: null
  };

  horizontalOptions: OptionsList[] = [
    {
      id: 'justify-content-center',
      name: 'center'
    },
    {
      id: 'justify-content-start',
      name: 'Left'
    },
    {
      id: 'justify-content-end',
      name: 'Right'
    }
  ];

  verticalOptions: OptionsList[] = [
    {
      id: 'align-items-center',
      name: 'center'
    },
    {
      id: 'align-items-start',
      name: 'Top'
    },
    {
      id: 'align-items-end',
      name: 'Bottom'
    }
  ];

  changeTranslate() {
    this.translate = this.element.fields.translate;
    const translatableFields = ['title', 'description', 'button1Text', 'button2Text'];
    if (this.translate) {
      translatableFields.forEach(field => {
        let currentValue = this.element.fields[field];

        if (typeof currentValue === 'string' || !currentValue) {
          currentValue = {
            value: currentValue || '',
            i18n: {}
          };
        }

        this.translateLangs.forEach((lang: string) => {
          if (!currentValue.i18n[lang]) {
            currentValue.i18n[lang] = currentValue.value;
          }
        });

        this.element.fields[field] = currentValue;
      });
    } else {
      translatableFields.forEach(field => {
        const currentValue = this.element.fields[field];

        if (currentValue && typeof currentValue === 'object' && 'value' in currentValue) {
          this.element.fields[field] = {
            ...currentValue,
            value: currentValue.value
          };
        }
      });
    }
  }

  uploadImage() {
    const fn = async (files: File[]) => {
      const imageObject = {
        index: 0,
        description: 'custompage image - ' + new Date().getTime(),
        category: 'custompage image',
        s3Uri: 'images/no-image.jpg'
      };
      const formData = new FormData();
      formData.append('file', files[0]);
      formData.append('productImage', JSON.stringify(imageObject));
      this.customPagesService.uploadImageS3(formData);
      return await firstValueFrom(this.customPagesService.uploadImageS3(formData));
    };
    this.modalService
      .openUploadModalComponent(fn, true, true, 'image/jpg, image/jpeg, image/png', {
        translateTag: 'UPLOAD_BACKGROUD_IMAGE',
        class: 'mb-2 text-center'
      })
      .then(res => {
        if (res) {
          this.element.fields.backgroundImage = `https://cdn3.gung.io/${res.s3Uri}`;
        }
      });
  }
}
